import { NgModule } from '@angular/core';
import { AdminComponent } from './admin.component';
import { SharedModule } from '@app/shared';
import { DbmAdditionalProprtiesOptionsModule } from '@app/shared/components/dbm-components/dbm-proprties-additional-options/dbm-additional-proprties.module';
import { PropertiesComponent } from '@app/authorized/admin/properties/properties.component';
import { AgentsComponent } from '@app/authorized/admin/agents/agents.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AgentClusterComponent } from '@app/authorized/admin/agent-cluster/agent-cluster.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [SharedModule, DbmAdditionalProprtiesOptionsModule, MatExpansionModule, MatProgressSpinnerModule],
    declarations: [AdminComponent, PropertiesComponent, AgentsComponent, AgentClusterComponent],
    entryComponents: [AdminComponent],
    exports: [AdminComponent]
})
export class AdminModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/admin/admin.module.ts